export default __webpack_public_path__ + "static/media/loss-cutting-point-trade-750x490.1adbd536.jpeg";